module.exports = __webpack_public_path__ + "img/img_sub_ser_outsourcing02.b6fab409.svg";